import { render, staticRenderFns } from "./PurchaseOrderRepair.vue?vue&type=template&id=c23a2e56"
import script from "./PurchaseOrderRepair.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports